import { z } from 'zod';
import { requiredString } from '../helpers';
export const Twilio_Start_Payment_1_ConfigValidator = z.object({
    paymentConnector: requiredString('Payment Connector is required'),
    chargeAmount: requiredString('Charge Amount is required'),
    tokenType: z.enum(['one-time', 'reusable']).optional(),
    collectSecurityCode: z.boolean().optional(),
    collectPostalCode: z.boolean().optional()
});
//# sourceMappingURL=twilio-start-payment-1.js.map